interface MovieCardProps {
  id: string;
  title: string;
  year: number;
  rating: number;
  genre: string;
  quality: string;
  imageUrl: string;
  isHot?: boolean;
  isNew?: boolean;
  linkTo: string;
}

export default function MovieCard({
  id,
  title,
  year,
  rating,
  genre,
  quality,
  imageUrl,
  isHot,
  isNew,
  linkTo,
}: MovieCardProps) {
  return (
    <a
      href={linkTo}
      data-product-shop
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={imageUrl}
          alt={`${title} - 草民影院高清电影在线观看`}
          title={`${title} 蓝光1080P在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>

        {quality && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-white rounded whitespace-nowrap">
            {quality}
          </span>
        )}
        {isHot && (
          <span className="absolute top-2 right-2 px-2 py-0.5 text-[10px] font-medium bg-accent-500 text-white rounded whitespace-nowrap">
            热门
          </span>
        )}
        {isNew && !isHot && (
          <span className="absolute top-2 right-2 px-2 py-0.5 text-[10px] font-medium bg-secondary-500 text-white rounded whitespace-nowrap">
            新上
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <div className="flex items-center gap-2 text-white text-xs">
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
              <span className="font-semibold">{rating}</span>
            </span>
            <span className="opacity-70">{year}</span>
          </div>
        </div>
      </div>

      <div className="p-3">
        <h3 className="font-heading font-bold text-foreground-900 text-sm leading-tight line-clamp-1 group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{genre}</p>
      </div>
    </a>
  );
}